export const EMAILING_CONSTS = {
    GET_EMAILING:"GET_EMAILING",
    POST_EMAILING:"POST_EMAILING",
    DELETE_EMAILING:"DELETE_EMAILING",
    RESEND_EMAILING:"RESEND_EMAILING",
};